import React from "react";

interface NoDataTextProps {
    message?: string;
    className?: string;
    style?: React.CSSProperties;
}

const NoDataText: React.FC<NoDataTextProps> = ({
    message = "No Data",
    className = "",
    style = {},
}) => {
    const defaultStyle: React.CSSProperties = {
        color: "#919191",
        fontSize: 14,
        fontStyle: "italic",
        textAlign: "center",
        fontWeight: "500 !important",
        padding: "0px 0",
        ...style,
    };

    return (
        <div className={`text-center ${className}`} style={defaultStyle}>
            <div>{message}</div>
        </div>
    );
};

export default NoDataText;